export default __webpack_public_path__ + "static/media/chevron-up-solid.b608d9bb.svg";